var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as rootActions from '../Root/actions';
import toast from '../../components/Toast';
import services from '../../services';
import { checkOrgStatusSummery } from '../../store/orgStatusSummery/actions';
var OrganizationService = services.OrganizationService, BundleService = services.BundleService, SignupService = services.SignupService;
export var assignPaymentMethodToOrganization = function (org, paymentMethodId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var stripe, resp, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'PaymentModal/CARD_ASSIGN_REQUEST' });
                    return [4 /*yield*/, OrganizationService.assignPaymentMethodToOrganization(org, paymentMethodId)];
                case 1:
                    stripe = (_a.sent()).object;
                    if ((stripe === null || stripe === void 0 ? void 0 : stripe.code) && (stripe === null || stripe === void 0 ? void 0 : stripe.type)) {
                        dispatch({ type: 'PaymentModal/CARD_ASSIGN_FAILURE', action: stripe });
                        toast.error(stripe.message);
                    }
                    else {
                        resp = __assign(__assign({}, stripe), { cardState: 'CARD_SAVED' });
                        dispatch({ type: 'PaymentModal/CARD_ASSIGN_SUCCESS', action: resp });
                        dispatch(checkOrgStatusSummery(org));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error(e_1);
                    dispatch({ type: 'PaymentModal/CARD_ASSIGN_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var assignPaymentMethodToSignup = function (paymentMethodId, country) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var stripe, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'PaymentModal/CARD_ASSIGN_REQUEST' });
                    return [4 /*yield*/, SignupService.assignPaymentMethodToSignup(paymentMethodId, country)];
                case 1:
                    stripe = (_a.sent()).object;
                    if ((stripe === null || stripe === void 0 ? void 0 : stripe.code) && (stripe === null || stripe === void 0 ? void 0 : stripe.type)) {
                        dispatch({ type: 'PaymentModal/CARD_ASSIGN_FAILURE', action: stripe });
                        toast.error(stripe.message);
                    }
                    else {
                        dispatch({ type: 'PaymentModal/CARD_ASSIGN_SUCCESS' });
                        dispatch(rootActions.checkCustomerCardSignup());
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    console.error(e_2);
                    dispatch({ type: 'PaymentModal/CARD_ASSIGN_FAILURE', action: e_2 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var purchaseBundlesAvailableByOrg = function (orgId, bundleId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'PaymentModal/PURCHASE_BUNDLES_REQUEST' });
                    return [4 /*yield*/, BundleService.purchaseBundlesAvailableByOrg(orgId, bundleId)];
                case 1:
                    _a.sent();
                    dispatch({
                        type: 'PaymentModal/PURCHASE_BUNDLES_SUCCESS',
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    dispatch({ type: 'PaymentModal/PURCHASE_BUNDLES_FAILURE', err: err_1 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var getClientSecret = function (org, bundleId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var card, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'PaymentModal/GET_SECRET_REQUEST' });
                    return [4 /*yield*/, OrganizationService.getClientSecret(org, bundleId)];
                case 1:
                    card = (_a.sent()).object;
                    dispatch({ type: 'PaymentModal/GET_SECRET_SUCCESS', action: card });
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    console.error(e_3);
                    dispatch({ type: 'PaymentModal/GET_SECRET_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var setConfirmPaymentStatus = function (status, error) {
    return function (dispatch) {
        if (status === 'loading')
            dispatch({ type: 'PaymentModal/CONFIRM_PAYMENT_REQUEST' });
        if (status === 'success')
            dispatch({ type: 'PaymentModal/CONFIRM_PAYMENT_SUCCESS' });
        if (status === 'error')
            dispatch({ type: 'PaymentModal/CONFIRM_PAYMENT_FAILURE', action: error });
    };
};
export var resetModalState = function () {
    return function (dispatch) {
        dispatch({ type: 'PaymentModal/RESET_MODAL' });
    };
};
export var resetPaymentState = function () {
    return function (dispatch) {
        dispatch({ type: 'PaymentModal/RESET_PAYMENT' });
    };
};
export var changeModalMode = function (mode) {
    return function (dispatch) {
        dispatch({ type: 'PaymentModal/CHANGE_MODAL_MODE', action: mode });
    };
};
export var changeInputMode = function (mode) {
    return function (dispatch) {
        dispatch({ type: 'PaymentModal/CHANGE_INPUT_MODE', action: mode });
    };
};
export var createInvoice = function (organizationId, bundleId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var card, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'PaymentModal/CREATE_INVOICE_REQUEST' });
                    return [4 /*yield*/, OrganizationService.createInvoice(organizationId, bundleId)];
                case 1:
                    card = (_a.sent()).object;
                    dispatch({ type: 'PaymentModal/CREATE_INVOICE_SUCCESS', action: card });
                    return [3 /*break*/, 3];
                case 2:
                    e_4 = _a.sent();
                    console.error(e_4);
                    dispatch({ type: 'PaymentModal/CREATE_INVOICE_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var setClientSecret = function (secret) { return function (dispatch) {
    dispatch({ type: 'PaymentModal/SET_CLIENT_SECRET', action: secret });
}; };
export var resetClientSecret = function () { return function (dispatch) {
    dispatch({ type: 'PaymentModal/RESET_CLIENT_SECRET' });
}; };
